import { Link, useLocation } from "react-router-dom";
import { routes } from "@/router/all_routes";

interface DashboardNavProps {
  showFinance?: boolean;
  showOperations?: boolean;
}

export function DashboardNav({ showFinance = true, showOperations = true }: DashboardNavProps) {
  const { pathname } = useLocation();

  const items = [
    { to: routes.tenantDashboard, label: "Vue exécutive", active: pathname === routes.tenantDashboard },
    ...(showFinance
      ? [
          {
            to: routes.dashboardFinance,
            label: "Santé financière",
            active: pathname === routes.dashboardFinance,
          },
        ]
      : []),
    ...(showOperations
      ? [
          {
            to: routes.dashboardOperations,
            label: "Performance opérationnelle",
            active: pathname === routes.dashboardOperations,
          },
        ]
      : []),
  ];

  return (
    <nav className="ph-dashboard-nav d-flex flex-wrap gap-2" aria-label="Vues tableau de bord">
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={`btn btn-sm ${item.active ? "btn-light fw-semibold shadow-sm" : "btn-outline-light"}`}
          aria-current={item.active ? "page" : undefined}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
